(function() {
	 
	const KEYCODE = {
		SPACE: 32,
	};
	
	class Notification extends HTMLElement 
	{
		
		
		
		static get observedAttributes() {
			return ['align', 'target', 'id'];
		}
		
		
		
		/* 
		 * The element's constructor is run anytime a new instance is created. 
		 * Instances are created either by parsing HTML, calling 
		 * document.createElement('howto-checkbox'), or calling new HowToCheckbox(); 
		 * The constructor is a good place to create shadow DOM, though you should 
		 * avoid touching any attributes or light DOM children as they may not be available yet.
		 */
		constructor() 
		{
			super();
	
			const shadow = this.attachShadow({ mode: 'open' });
			
			const wrapper = this.getMarkup();
			const styles = this.getStyles();
		
			shadow.appendChild(styles);
			shadow.appendChild(wrapper);
			
			this._onClick = this._onClick.bind(this);
			this._onClose = this._onClose.bind(this);
		}
		
		

		
		
		
		
		
		/*
		 * connectedCallback() fires when the element is inserted into the DOM. 
		 * It's a good place to set the initial role, tabindex, internal state, and install event listeners.
		 * 
		 * A user may set a property on an instance of an element, before its prototype has been connected to this class. 
		 * The _upgradeProperty() method will check for any instance properties and run them through 
		 * the proper class setters. See the lazy properties section for more details.
		 */
		connectedCallback() 
		{
			const _this = this;
			if (!this.hasAttribute('role') ) {
				this.setAttribute('role', 'alertdialog');
			}
						
			this.addEventListener('click', this._onClick);
			
			const shadow = this.shadowRoot;
			shadow.querySelector('.txn--close').addEventListener('click', this._onClose);
			
			let show = true; 
			if( window.sessionStorage ) {
				if( sessionStorage.getItem(this.id) ) {
					show = false;
				} 
			}
			
			if( show ) {
				const timer = setTimeout(() => {
					_this._show();	
				}, 1000);
			}
			
		}
		
		
		
		
		
		/* 
		 * disconnectedCallback() fires when the element is 
		 * removed from the DOM. 
		 * It's a good place to do clean up work like releasing 
		 * references and removing event listeners.
		 */
		disconnectedCallback() 
		{
			const shadow = this.shadowRoot;
			shadow.querySelector('.txn--close').removeEventListener('click', this._onClose);
			this.removeEventListener('click', this._onClick);
		}
		
		
		_show() 
		{
			const shadow = this.shadowRoot;
			shadow.querySelector('.tix02-notification').classList.add('shown');
		}
		
		
		_close() 
		{
			if( window.sessionStorage ) {
				sessionStorage.setItem(this.id, 1);
			}
				
			// close me 
			const shadow = this.shadowRoot;
			shadow.querySelector('.tix02-notification').classList.remove('shown');
		}
		

		
		
		
		_onClick(event) 
		{
			event.preventDefault();
			event.stopImmediatePropagation();
			
			if( this.target ) {	
				this._close();
				document.location.href = this.target;
			}
		}
		
		
		
		_onClose(event) 
		{
			event.preventDefault();
			event.stopImmediatePropagation();
			this._close();
		}
		
		
		
		
		getMarkup() 
		{
			const _this = this;
			
			const wrapper = document.createElement('div');
			const alignClass = this.getAttribute('align') || 'bl';
			wrapper.classList.add('tix02-notification', alignClass);
		
			const inner = document.createElement('div');
			inner.classList.add('txn--inner', 'txn--button');
			
			const slot = document.createElement('slot');
			inner.appendChild(slot);
			this._inner = inner;
			
			const closeBtn = document.createElement('button');
			closeBtn.classList.add('txn--close');
			
			wrapper.appendChild(closeBtn);
			wrapper.appendChild(inner); 
			
			return wrapper;
		}

		
		get target() 
		{
			return this.getAttribute('target') || '';
		}
		
		get id() 
		{
			return this.getAttribute('id');
		}

		
		get alignment() 
		{
			const alignment = this.getAttribute('align') || 'bl';
			const x = '20px';
			const y = '40px';
			
			switch(alignment) {
				case 'tl':
				case 'lt':
					return {
						top: y,
						left: x,
						bottom:'auto',
						right:'auto'
					};
				
				case 'tr':
				case 'rt':
					return {
						top: y,
						left: 'auto',
						bottom:'auto',
						right: x
					};
				
				case 'br':
				case 'rb':
					return {
						top: 'auto',
						left: 'auto',
						bottom: y,
						right: x
					};
				
				case 'bl':
				case 'lb':
				default:
					return {
						top: 'auto',
						left: x,
						bottom: y,
						right:'auto'
					};
			}
		}
		
		
		
		
		getStyles() 
		{
			
			//const posh = '40px';
			//const posv = '20px';
			
			const a = this.alignment;
			
			
			const style = document.createElement('style');
			style.textContent = `
				:host {
					display:inline-block;
					position:fixed;
					z-index:999999999;
					width:450px;
					max-width:100%;
					pointer-events:none;
					top: ${a.top};
					right: ${a.right};
					bottom: ${a.bottom};
					left: ${a.left};
				}
				
				:host([disabled]) {
					opacity:.5;
				}
				
				:host * {
					margin:0;
					border:0;
					padding:0;
					box-sizing:border-box;
				}
				
				.tix02-notification {
					display:block;
					/*position:absolute;*/
					padding:20px 30px;
					width:100%;
					color:#13223e;
					background-color:rgba(255,255,255,.95);	
					border-radius:10px;
					border:1px solid #efefef;
					box-shadow:0 0 20px rgba(0,0,0,.10);
					opacity:0;
					-webkit-transition:all .5s ease;
					transition:all .5s ease;
					-webkit-user-select: none;
					-moz-user-select: none;
					-ms-user-select: none;
					user-select:none;
					font-size:1.1em;
				}

				
				
				
				/* Top */
				.tix02-notification.tl,
				.tix02-notification.lt,
				.tix02-notification.tr,
				.tix02-notification.rt {
					transform:translateY(-100%);
				}
				
				
				/* Bottom */
				.tix02-notification.bl,
				.tix02-notification.lb,
				.tix02-notification.br,
				.tix02-notification.rb {
					transform:translateY(100%);
					
				}
				
				
				.tix02-notification.shown {
					opacity:1;
					pointer-events:all;
					transform:translateY(0%) !important;
				}
				
				.txn--inner {
					padding-right:20px;
					cursor:pointer;
				}
				
				.txn--close {
					position:absolute;
					top:10px;
					right:10px;
					width:24px;
					height:24px;
					-webkit-appearance:none;
					border:0;
					background:transparent;
				}
				.txn--close::before, 
				.txn--close::after {
					position:absolute;
					top:50%;
					left:50%;
					width:14px;
					height:1px;
					background-color:#000;
					content:'';
					-webkit-transform-origin:50% 50%;
					transform-origin:50% 50%;
				}
					
				.txn--close::before {
					-webkit-transform: translateX(-50%) rotate(-45deg);
					transform: translateX(-50%) rotate(-45deg);
				}
					
				.txn--close::after {
					-webkit-transform: translateX(-50%) rotate(45deg);
					transform: translateX(-50%) rotate(45deg);
				}
			`;
			
			return style;
		}
	}
	
	
	window.customElements.define('tix02-notification', Notification);
})();
